import TextField, { TextFieldProps } from '~components/ui/text-input/text-field'
import { cn } from '~utils/cn'

interface Props extends TextFieldProps {
  errorMessage: string
  onNameChange: (name: string) => void
}

const PetName = ({ errorMessage, onNameChange, ...props }: Readonly<Props>) => {
  return (
    <TextField
      placeholder="e.g. cookie"
      value={props.value || ''}
      label={props.label}
      className={cn('w-full', props.className)}
      onChange={e => onNameChange(e.target.value)}
      error={!!errorMessage?.length}
      maxLength={20}
      showMaxLength={false}
      showHelper
      helperMessage={errorMessage}
    />
  )
}

export default PetName
